import { render, staticRenderFns } from "./EcommerceReports.vue?vue&type=template&id=01e8ce92&"
import script from "./EcommerceReports.vue?vue&type=script&lang=js&"
export * from "./EcommerceReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports